import { RecentViewedProducts } from 'components/desktop/organisms';
import React, { FC } from 'react';
import { SlotComponentProps } from '../../types';
import { LazyComponent } from 'components/LazyComponent';

export type RecentProductDesktopSlotProps = SlotComponentProps<{}>;

export const RecentProductDesktopSlot: FC<
  RecentProductDesktopSlotProps
> = () => {
  return <RecentViewedProducts />;
};

export const LazyRecentProductDesktopSlot: FC<RecentProductDesktopSlotProps> = (
  props,
) => {
  return (
    <LazyComponent>
      <RecentProductDesktopSlot {...props} />
    </LazyComponent>
  );
};
